<template>
  <div class="app-body">
    <div class="el-tabs__header" style="margin-bottom: 0;">
      <el-tag type="primary" :effect="dataForm.productType==='产品'?'dark':'plain'" @click="dataForm.productType='产品'"
              v-if="$hasPermission('erp:store:product:query')"
              style="font-size: 16px;height: 32px;line-height: 30px;cursor: pointer;">成品/配件库
      </el-tag>
      <el-tag type="primary" :effect="dataForm.productType==='原料'?'dark':'plain'" @click="dataForm.productType='原料'"
              v-if="$hasPermission('erp:store:material:query')"
              style="margin-left: 10px;font-size: 16px;margin-bottom:10px;height: 32px;line-height: 30px;cursor: pointer;">
        物料库
      </el-tag>
    </div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：">
        <order-drop v-model="dataForm.orderCode"></order-drop>
      </el-form-item>
      <el-form-item label="发货批次号：">
        <el-input size="mini" v-model="dataForm.batchCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="出口发票号：" prop="boxReceiptCode">
        <el-input size="mini" v-model="dataForm.boxReceiptCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货方：">
        <el-input size="mini" v-model="dataForm.senderName" clearable></el-input>
      </el-form-item>
      <el-form-item label="收货方：">
        <el-input size="mini" v-model="dataForm.receiverName" clearable></el-input>
      </el-form-item>
      <el-form-item prop="reason" label="变动原因：">
        <el-select v-model="dataForm.reason" size="mini" style="width: 100px;" clearable>
          <el-option value="" label="全部"></el-option>
          <el-option value="采购入库" label="采购入库" v-if="dataForm.productType==='原料'"></el-option>
          <el-option value="生产入库" label="生产入库" v-if="dataForm.productType==='产品'"></el-option>
          <el-option value="库存调配" label="库存调配"></el-option>
          <el-option value="箱单出库" label="箱单出库" v-if="dataForm.productType==='产品'"></el-option>
          <el-option value="库存初始化" label="库存初始化"></el-option>
          <el-option value="退货" label="退货"></el-option>
          <!--          <el-option value="产品生产材料扣减" label="产品生产材料扣减" v-if="productType==='原料'"></el-option>-->
        </el-select>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：" v-if="dataForm.productType==='产品'">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：" v-if="dataForm.productType==='产品'">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：" v-if="dataForm.productType==='原料'">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="请输入幅宽"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：" v-if="dataForm.productType==='原料'">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
        ></el-input>
      </el-form-item>
      <el-form-item prop="status" label="收货状态：">
        <el-select v-model="dataForm.status" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="未收货" value="10"></el-option>
          <el-option label="已收货" value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hasReceipt" label="开票情况：">
        <el-select v-model="dataForm.hasReceipt" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="未开票" value="0"></el-option>
          <el-option label="已开票" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hasBack" label="退货情况：">
        <el-select v-model="dataForm.hasBack" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="无退货" value="0"></el-option>
          <el-option label="有退货" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货时间：">
        <el-date-picker
            :clearable="true"
            v-model="sendDateRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期" size="mini"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="showReceiptCode" label="显示销售开票号"
                     v-if="dataForm.productType==='原料'"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar flex-b">
      <div class="flex-l">
        <el-button type="primary" v-if="$hasPermission('erp:store:send:factory')" size="mini" @click="doSend">
          发送至工厂
        </el-button>
        <file-link file-type="back" type="primary"
                   file-url="/erp/excel/file/export/all" :params="dataForm">导出EXCEL
        </file-link>
        <el-button class="bar-item" v-if=" $hasPermission('erp:store:receive')" @click="showInitImportDialog()"
                   size="mini"
                   type="warning">原始库存导入
        </el-button>
        <el-button class="bar-item" v-if=" $hasPermission('erp:store:receive')" @click="showReceiveDialog()" size="mini"
                   type="warning">确认收货
        </el-button>
        <el-button class="bar-item" v-if=" $hasPermission('erp:store:back')" @click="showBackDialog()" size="mini"
                   type="warning">退货
        </el-button>
        <el-button class="bar-item" v-if=" $hasPermission('erp:store:edit')" @click="showStoreLogEditDialog()"
                   size="mini"
                   type="danger">发货单修改
        </el-button>
        <el-button class="bar-item" v-if=" $hasPermission('store:log:delete')" @click="batchDel()" size="mini"
                   type="danger">批量删除
        </el-button>
        <el-button class="bar-item" v-if=" $hasPermission('erp:store:cancel:receive')" @click="batchCancelReceived()"
                   size="mini"
                   type="danger">取消确认收货
        </el-button>
        <el-button class="bar-item" v-if="$hasPermission('erp:bind:box')&&dataForm.productType==='产品'"
                   @click="showBindBoxDialog()" size="mini"
                   type="danger">绑定出口发票
        </el-button>
        <el-button class="bar-item" v-if="$hasPermission('erp:bind:box')&&dataForm.productType==='原料'"
                   @click="showBindBoxDialog('sell')" size="mini"
                   type="danger">绑定销售开票
        </el-button>
        <el-button class="bar-item" @click="uploadImg" type="warning" size="mini"
                   v-if="$hasPermission('erp:store:upload')">
          上传凭证
        </el-button>
        <el-button class="tool-item" type="warning" size="mini" v-if="$hasPermission('erp:store:transfer')"
                   @click="showTransferDialog()">库存调配
        </el-button>
        <el-button class="tool-item" type="warning" size="mini" v-if="$hasPermission('erp:receipt:bind')"
                   @click="showBindReceiptDialog()">进项发票绑定
        </el-button>
        <file-link file-type="back" v-if="$hasPermission('erp:product:receipt:export')&&dataForm.productType==='产品'"
                   type="warning"
                   file-url="/erp/excel/file/export/check" :params="dataForm">核价单导出
        </file-link>
        <el-button type="primary" v-if="$hasPermission('erp:product:receipt:import')&&dataForm.productType==='产品'"
                   size="mini"
                   @click="showProductReceiptImportDialog">
          进项发票导入
        </el-button>
      </div>
      <div class="flex-r">
        <div class="flex-l">
          <div style="width: 20px;height: 20px;background-color:#a400a2;margin: 0 4px 0 10px;"></div>
          <div style="color:#a400a2;">工厂端无法看到的历史数据</div>
        </div>
      </div>

    </div>
    <SweetTable ref="table" :selection="true" api-version="v2" url="/trade/factorystorelog/page" :auto-load="false"
                :query-form="dataForm" :before-table-binding="beforeTableBinding"
                :is-page="true"
                :summaries-column="['count','sendCount','backCount','transferCount']"
                :cell-style="cellStyleHandler">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <span>{{ row.orderCode }}</span>
          <el-tag type="success" style="margin-left: 6px;" size="mini"
                  v-if="row.orderStatus===$const.orderStatus.COMPLETED">已结束
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true"
      ></el-table-column>
      <el-table-column
          prop="boxReceiptCode"
          :label="dataForm.productType==='产品'?'出口发票号':'销售开票号'"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true" v-if="dataForm.productType==='产品'||showReceiptCode===true"
      ></el-table-column>
      <el-table-column
          prop="senderName"
          label="发货方"
          header-align="center"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="120"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column label="货物信息" min-width="300" :show-overflow-tooltip="true">
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
          <div v-if="row.upflowCount>0"
               style="color: rgb(164, 0, 162);border-radius: 2px;border: solid 1px rgb(164, 0, 162);background-color: rgb(164, 0, 162,0.3);font-size: 12px;width: 20px;height: 20px;display: flex;justify-content: center;align-items: center;">
            绑
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="发货数"
          header-align="center"
          align="center"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="收货数"
          header-align="center"
          align="center"
          prop="count"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="退货数"
          header-align="center"
          align="center"
          prop="backCount"
          width="80"
      >
        <template #default="{row}">
          <el-link type="danger" v-if="row.backCount>0" @click="showBackDetailDialog(row)">{{ row.backCount }}</el-link>
          <span v-else>{{ row.backCount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="调出数"
          header-align="center"
          align="center"
          prop="transferCount"
          width="80"
      >
        <template #default="{row}">
          <el-link type="danger" v-if="row.transferCount>0" @click="showBackDetailDialog(row)">{{
              row.transferCount
            }}
          </el-link>
          <span v-else>{{ row.transferCount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="发货单价"
          header-align="center"
          align="center"
          prop="price"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="操作原因"
          header-align="center"
          width="80"
          align="center"
          prop="reason"
      ></el-table-column>
      <el-table-column
          label="记录时间"
          header-align="center"
          align="left"
          width="220"
      >
        <template #default="{row}">
          <div>发货：{{ row.operateTime }}</div>
          <div>收货：{{ row.status === 10 ? '未确认收货' : row.receiveOptTime }}</div>
          <div>制单：{{ row.createDate }}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="操作人"
          header-align="center"
          width="140"
      >
        <template #default="{row}">
          <div>发货：{{ row.creatorName }}</div>
          <div>收货：{{ row.status === 10 ? '未确认收货' : row.receiveOptManName }}</div>
          <div>制单：{{ row.creatorName }}</div>
        </template>
      </el-table-column>

      <el-table-column
          label="进项发票"
          header-align="center"
          align="center"
          width="120" :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <span v-if="['库存调配','箱单发货'].indexOf(row.reason)>-1">{{ row.reason }}无需开票</span>
          <template v-else>
            <span v-if="row.status===10">未确认收货,无法开票</span>
            <span  style="color:chocolate;font-weight: 600;" v-else-if="row.receiptDetailId">{{ row.receiptCode ? row.receiptCode : '申请中' }}</span>
            <span v-else>未开票</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          label="备注及凭证"
          header-align="center"
          width="200" :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <el-button type="text" v-if="row.fullImgs.length>0" @click="showImagePreviewer(row)">
            查看凭证
          </el-button>
          {{ row.fullRemark }}
        </template>
      </el-table-column>
    </SweetTable>
    <ImagePreviewer ref="ImagePreviewer" :show-remove="true" @remove="imgRemoveHandler"></ImagePreviewer>
    <ProductReceiveDialog ref="ProductReceiveDialog" :source-table="sourceTable"
                          @change="getDataList"></ProductReceiveDialog>
    <BackDialog ref="BackDialog" @changed="getDataList"></BackDialog>
    <StoreLogEditDialog ref="StoreLogEditDialog" @changed="getDataList"></StoreLogEditDialog>
    <BackDetailDialog ref="BackDetailDialog"></BackDetailDialog>
    <BindBoxDialog ref="BindBoxDialog" @changed="getDataList"></BindBoxDialog>
    <image-upload-dialog ref="ImageUploadDialog" @completed="uploadImgCompleted"></image-upload-dialog>
    <TransferDialog ref="TransferDialog" :productType="dataForm.productType"
                    @changed="$refs.table.getDataList()"></TransferDialog>
    <BindReceiptDialog ref="BindReceiptDialog" @changed="$refs.table.getDataList()"></BindReceiptDialog>
    <InitImportDialog ref="InitImportDialog" :product-type="dataForm.productType"
                      @changed="$refs.table.getDataList()"></InitImportDialog>
    <ProductReceiptImportDialog ref="ProductReceiptImportDialog"
                                @changed="$refs.table.getDataList()"></ProductReceiptImportDialog>
    <MoveLogDialog v-if="dialogManager.moveLogDialog" ref="moveLogDialog"></MoveLogDialog>
  </div>
</template>

<script>
/**
 * 库存流水管理
 */
import MoveLogDialog from '@/views/modules/erp/store/log/move-log-dialog.vue'
import InitImportDialog from '@/views/modules/erp/store/log/init-import-dialog.vue'
import BindReceiptDialog from '@/views/modules/erp/store/log/bind-receipt-dialog.vue'
import FileLink from '@/components/FileLink.vue'
import ImageUploadDialog from '@/components/ImageUploadDialog'
import BindBoxDialog from '@/views/modules/erp/store/log/bind-box-dialog.vue'
import TransferDialog from './transfer-dialog.vue'
import StoreLogEditDialog from '@/views/modules/erp/store/StoreLogEditDialog.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'
import ProductReceiveDialog from '@/components/ProductReceiveDialog.vue'
import SweetTable from '@/mixins/SweetTable'
import ImagePreviewer from '@/components/ImagePreviewer.vue'
import moment from 'moment'
import BackDialog from '@/views/modules/erp/store/BackDialog.vue'
import ProductReceiptImportDialog from '@/views/modules/erp/receipt/ProductReceiptImportDialog.vue'

export default {
  mixins: [SweetTable],
  components: {
    ImagePreviewer,
    ProductReceiveDialog,
    ProductRowCard,
    BindBoxDialog,
    BackDetailDialog: () => {
      return import('@/views/modules/erp/purchase/BackDetailDialog.vue')
    },
    StoreLogEditDialog,
    BackDialog,
    ImageUploadDialog,
    TransferDialog,
    FileLink,
    BindReceiptDialog,
    InitImportDialog,
    ProductReceiptImportDialog,
    MoveLogDialog
  },
  data () {
    return {
      dateArr: [],
      dialogManager: {
        moveLogDialog: false
      },
      showReceiptCode: false,
      dataForm: {
        reason: '',
        productType: '产品',
        hasReceipt: '',
        hasBack: '',
        fuzzyOrderCode: '',
        status: null,
        orderCode: '',
        batchCode: '',
        sellerName: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        sourceType: this.sourceType,
        sendDateBegin: '',
        sendDateEnd: '',
        queryType: this.queryType,
        isVirtual: null,
        senderName: ''
      },
    }
  },

  computed: {
    //兼容不同的sourceType和sourceTable取值
    sourceTable () {
      if (this.sourceType === 'make') {
        return 'ma_factory_make_detail'
      } else if (this.sourceType === 'purchase') {
        return 'ma_purchase'
      }
    },
    sendDateRange: {
      get: function () {
        return [this.dataForm.sendDateBegin, this.dataForm.sendDateEnd]
      },
      // setter
      set: function (newVal) {
        this.dataForm.sendDateBegin = newVal[0]
        this.dataForm.sendDateEnd = newVal[1]
      }
    }
  },
  watch: {
    showReceiptCode: {
      handler: function (newVal) {
        this.$refs.table.doLayout()
      }
    },
    'dataForm.productType': function (newVal) {
      this.reload()
    },
    sourceType: {
      handler: function (newVal) {
        this.dataForm.sourceType = newVal
        this.reload()
      },
      immediate: true
    }
  },
  methods: {
    //显示凭证图片预览弹窗
    showImagePreviewer (row) {
      this.$refs.ImagePreviewer.sourceData=row
      this.$refs.ImagePreviewer.init(row.fullImgs)
    },
    async imgRemoveHandler (item, sourceData) {
      await this.$api2.post('/erp/store/removeImg', { id: sourceData.id, removeImg: item })
      this.$message.success('操作成功')
      this.getDataList()
    },
    //显示往来
    //显示进项发票导入弹窗
    showProductReceiptImportDialog () {
      this.$refs.ProductReceiptImportDialog.init()
    },
    showInitImportDialog () {
      this.$refs.InitImportDialog.init()
    },
    doSend () {
      let rows = this.getSelectedRows()
      if (this.$c.isArrayEmpty(rows)) {
        this.$message.error('请选择要发送的记录')
        return
      }
      let ids = rows.map(row => row.id)
      this.$confirm('确认发送选中的记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api2.post('/erp/store/send', { ids: ids }).then(res => {
          this.$message.success('发送成功')
          this.$refs.table.getDataList()
        })
      })
    },
    showTransferDialog () {
      let rows = this.$refs.table.dataListSelections
      if (rows.length === 0) {
        return this.$message.error('请选择要调仓的批次')
      }
      const data = this.$clone(rows)
      let outStorageId = ''
      data.forEach((item) => {
        item.count = ''
        item.senderId = item.receiverId
        item.senderName = item.receiverName
        item.receiverId = ''
        item.receiverName = ''
      })
      this.$refs.TransferDialog.dataForm.checkOutStorageId = outStorageId
      this.$refs.TransferDialog.dataForm.detailList = data
      this.$refs.TransferDialog.init()
    },
    //上传图片凭证
    uploadImg () {
      let rows = this.$refs.table.dataListSelections
      if (rows.length === 0) {
        return this.$message.error('请选择出入库记录')
      }
      this.$refs.ImageUploadDialog.init()
    },
    //批量更新出入库记录图片
    uploadImgCompleted (imgs) {
      if (!imgs) {
        return this.$message.error('请上传图片')
      }
      let imgObj = JSON.parse(imgs)
      let rows = this.$refs.table.dataListSelections
      let ids = rows.map(item => item.id).join(',')
      this.$http.post(`/store/update/imgs`, { ids: ids, imgs: imgObj.join(',') }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.$refs.table.getDataList()
      })
    },
    //绑定出口发票
    //出口发票type=outlet  内销发票type=sell
    showBindBoxDialog (type) {
      if (!type) {
        type = 'outlet'
      }
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要绑定的记录')
      }
      this.$refs.BindBoxDialog.type = type
      this.$refs.BindBoxDialog.init(rows)
    },
    //绑定出口发票
    showBindReceiptDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要绑定的记录')
      }

      this.$refs.BindReceiptDialog.init(rows)
    },
    batchCancelReceived () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要取消的记录')
      }
      let confirmMsg = `确定要取消确认收货?`
      this.$confirm(confirmMsg, '提示').then(() => {
        this.$api2.post('/trade/factorystorelog/cancel/receive', { ids: rows.map(item => item.id) }).then(res => {
          this.$message.success('操作成功')
          this.reload()
          this.clearSelection()
        })
      })
    },
    //批量删除
    batchDel () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要删除的记录')
      }
      let confirmMsg = `确定要删除选中的记录么?`
      this.$confirm(confirmMsg, '提示').then(() => {
        this.$api2.post('/erp/store/log/del', { ids: rows.map(item => item.id) }).then(res => {
          this.$message.success('删除成功')
          this.reload()
          this.clearSelection()
        })
      })
    },
    //返回勾选的行数据
    getSelectedRows () {
      if (!this.$refs.table) {
        return []
      }
      return this.$refs.table.dataListSelections
    },
    showBackDetailDialog (row) {
      this.$refs.BackDetailDialog.init(row.id)
    },
    cellStyleHandler ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'orderCode') {
        if (row.orderStatus === this.$const.orderStatus.COMPLETED) {
          return {
            color: '#7e6aff'
          }
        }
      }
      if (column.property === 'count' || column.property === 'sendCount') {
        if (row.type === -1) {
          return {
            color: 'red',
            fontWeight: '600'
          }
        }
      }
      if (column.property === 'senderName' || column.property === 'receiverName') {
        if (row.isVirtual === 0) {
          return {
            color: '#a400a2'
          }
        }
      }
    },
    showStoreLogEditDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要修改的记录')
      }
      if (rows.length > 1) {
        return this.$message.warning('只能选择一条记录进行修改')
      }
      this.$refs.StoreLogEditDialog.init(rows[0])
    },
    //显示退货弹窗
    showBackDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要调整单价的记录')
      }
      if (rows.length > 1) {
        return this.$message.warning('只能选择一条记录进行调整单价')
      }

      this.$refs.BackDialog.init(rows[0])
    },
    //显示调整单价弹窗
    showChangePriceDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要调整单价的记录')
      }
      if (rows.length > 1) {
        return this.$message.warning('只能选择一条记录进行调整单价')
      }

      this.$refs.ChangePriceDialog.init(rows[0])
    },
    //显示公司端确认收货弹窗
    showReceiveDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要确认收货的记录')
      }
      let receiveDataList = rows.map(row => {
        return {
          orderCode: row.orderCode,
          batchCode: row.batchCode,
          id: row.id,
          productId: row.productId,
          product: row.product,
          sendDate: row.operateTime,
          senderName: row.senderName,
          sendCount: row.sendCount,
          receiveCount: row.sendCount,
          sourceTable: this.sourceTable,
          receiveOptTime: moment().format('YYYY-MM-DD'),
        }
      })
      this.$refs.ProductReceiveDialog.init(receiveDataList)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.count = row.count * row.type
        row.sendCount = row.sendCount * row.type
        row.fullRemark = [row.remark, row.sendRemark, row.receiveRemark].join(' ')
        row.fullImgs = []
        if (row.imgs) {
          row.imgs = JSON.parse(row.imgs)
          row.fullImgs = row.fullImgs.concat(row.imgs)
        }
        if (row.sendImgs) {
          row.sendImgs = JSON.parse(row.sendImgs)
          row.fullImgs = row.fullImgs.concat(row.sendImgs)
        }
        if (row.receiveImgs) {
          row.receiveImgs = JSON.parse(row.receiveImgs)
          row.fullImgs = row.fullImgs.concat(row.receiveImgs)
        }
      })
    },

  },
  activated () {
    if (this.$hasPermission('erp:store:product:query')) {
      this.dataForm.productType = '产品'
    } else if (this.$hasPermission('erp:store:material:query')) {
      this.dataForm.productType = '原料'
    } else {
      this.dataForm.productType = '--'
    }
    console.log('11111111111')
  }
}
</script>

<style lang="scss" scoped>

</style>
